import React, { FC, useMemo } from 'react';
import { SanityImage, SanityImageRotation } from 'superclient';
import ImageBackground from './image-background';
import { Superclient } from '../../clients/superclient';

const ImageBackgroundSanity: FC<{
  image?: SanityImage;
  fadeIn?: boolean;
  alt?: string;
  lazyLoad?: boolean;
  className?: string;
  width?: number;
  height?: number;
  orientation?: SanityImageRotation;
}> = ({ image, fadeIn, alt, lazyLoad, className, width, height, orientation }) => {
  const src = useMemo(() => {
    let isSVG = false;
    if (image && image) {
      const sanityUrl = image.asset.url;
      isSVG = sanityUrl.endsWith('.svg') || sanityUrl.endsWith('.SVG');
      if (isSVG) {
        return sanityUrl;
      } else {
        return (
          Superclient.getImageUrl(image, width, height, 2, orientation) || undefined
        );
      }
    }
    return undefined;
  }, [image, orientation, width, height]);

  return (
    <ImageBackground
      source={src}
      fadeIn={fadeIn}
      alt={alt}
      lazyLoad={lazyLoad}
      className={className}
    />
  );
};

export default ImageBackgroundSanity;
